// extracted by mini-css-extract-plugin
export default {"blackButton":"styles_blackButton__vX4Qy","blackButtonDisabled":"styles_blackButtonDisabled__DZBCD"};